import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { getFetch } from "../../fetch/fetch";
import { URL } from "url";


const fileList = [
    {
        name: "사전 심층 조사지",
        thumbname: "deepresearchimage.webp",
        filloutId: "fLQtVrEXaLus",
        key: "deepResearch"
    },
    {
        name: "주간 스케쥴",
        thumbname: "weekscheduler.webp",
        filloutId: "tUnvGhvNP4us",
        key: "weekSchedule"
    }
]

const MobileSubmitFiles: React.FC<any> = (props) => {

    const history = useHistory();
    const [data, setData] = useState<any>({
        deepResearch: null,
        weekSchedule: null
    })
    const [justFinishData, setJustFinishData] = useState<any>({
        deepResearch: false,
        weekSchedule: false
    });
    const location = useLocation<any>();
    const [classReportLink, setClassReportLink] = useState<string>("");

    useEffect(() => {

        getData();

    }, []);

    const getData = async () => {

        try {

            const result: any = await getFetch("/dashboard/mycoach/getcoachingfiles");

            console.log(result);

            if (result && result.message === "success") {

                const data = result.data;

                if (!data) {
                    return;
                }

                const newData: any = {
                    deepResearch: data.deepResearch,
                    weekSchedule: data.weekSchedule
                }

                const newJustFinishData: any = {
                    deepResearch: false,
                    weekSchedule: false
                }

                if (!data.deepResearch) {
                    if (location && location.state && location.state.deepResearchFinish) {
                        newJustFinishData.deepResearch = true;
                    }
                }

                if (!data.weekSchedule) {
                    if (location && location.state && location.state.weekScheduleFinish) {
                        newJustFinishData.weekSchedule = true;
                    }
                }

                setJustFinishData({ ...newJustFinishData });
                setData({ ...newData });

                if(data.classReportLink) {
                    setClassReportLink(data.classReportLink);
                }

            }

        } catch (e) {
            console.log(e);
        }
    }

    return (
        <div>
            <div style={{
                width: "90.6%",
                margin: "0 auto",
                backgroundColor: "#f0f0f0",
                borderRadius: "12px",
                padding: "1rem",
                marginTop: "1rem"
            }}>
                <div style={{
                    marginBottom: "0.5rem",
                    fontSize: "0.8rem"
                }}>
                    코칭 준비 자료
                </div>
                {
                    fileList.map((item, index) => {

                        const src = `img/${item.thumbname}`;

                        return (
                            <div key={index} style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "0.5rem 0",
                            }}
                                onClick={() => {

                                    console.log(props.user);

                                    if (!props.user) {
                                        alert("로그인이 필요합니다.");
                                        return;
                                    }

                                    if (justFinishData[item.key]) {
                                        return;
                                    }

                                    history.push(
                                        {
                                            pathname: "/mobiledashboard/filloutembed",
                                            state: {
                                                userId: props.user.id,
                                                filloutId: item.filloutId,
                                                returnUrl: "/mobiledashboard/mycoaching",
                                                nextCurrentStatus: 3,
                                                title: item.name,
                                                _t: (data[item.key] && data[item.key].editLink) ? data[item.key].editLink.split("?")[1].split("&").find((param: any) => param.startsWith("_t=")).split("=")[1] : undefined,
                                                deepResearchFinish: item.key === "deepResearch" ? true : false,
                                                weekScheduleFinish: item.key === "weekSchedule" ? true : false,
                                            }
                                        });
                                }}
                            >
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}>
                                    <div style={{
                                        backgroundColor: "#ffffff",
                                        width: "28px",
                                        height: "28px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderRadius: "8px",
                                        marginRight: "0.5rem",
                                        flexShrink: 0,
                                        flexGrow: 0,
                                    }}>
                                        <img src={src} alt={item.name} style={{ width: "16px", height: "auto" }} />
                                    </div>
                                    <div style={{
                                        fontSize: "0.9rem"
                                    }}>
                                        {item.name}
                                    </div>
                                </div>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}>
                                    <div style={{
                                        fontSize: "0.7rem",
                                        marginRight: "0.6rem"
                                    }}>
                                        {justFinishData[item.key] ? "작성 완료" : data[item.key] ? "수정하러 가기" : "작성하러 가기"}
                                    </div>
                                    {/* <div>
                                        <img src="/img/chevron-right-light.svg"
                                            style={{
                                                width: "6px"
                                            }}
                                        />
                                    </div> */}
                                </div>
                            </div>
                        )

                    })
                }
                {
                    classReportLink
                        ?
                        <>
                            <div style={{
                                marginBottom: "0.5rem",
                                fontSize: "0.8rem",
                                marginTop: "1.5rem"
                            }}>
                                수업 기록지
                            </div>
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "0.5rem 0",
                            }}
                                onClick={async () => {

                                    console.log(props.user);

                                    if (!props.user) {
                                        alert("로그인이 필요합니다.");
                                        return;
                                    }

                                    window.open(`${classReportLink}`, "_blank");

                                }}
                            >
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}>
                                    <div style={{
                                        backgroundColor: "#ffffff",
                                        width: "28px",
                                        height: "28px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        borderRadius: "8px",
                                        marginRight: "0.5rem",
                                        flexShrink: 0,
                                        flexGrow: 0,
                                    }}>
                                        <img src={"/img/classreport.webp"} alt={"classreport"} style={{ width: "16px", height: "auto" }} />
                                    </div>
                                    <div style={{
                                        fontSize: "0.9rem"
                                    }}>
                                        수업 기록지 링크
                                    </div>
                                </div>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                }}>
                                    <div style={{
                                        fontSize: "0.7rem",
                                        marginRight: "0.6rem"
                                    }}>
                                        링크 접속하기
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        ""
                }
            </div>
        </div>
    )
}

export default MobileSubmitFiles;